<template>
    <div class="modal-wrapper"
         ref="alternativeModal"
         id="modal-wrapper"
         @click="closeModalOutside($event)">
        <div id="modal" class="modal">
            <button class="btn--close"
                    @click="closeModal()">
                <span class="fas fa-times"></span>
            </button>

            <h4 class="mb-12">{{ $t("productNotAvailable") }}</h4>
            <div v-for="item in productsData.alternatives"
                 :key="item.id"
                 class="product-snippet">

                <div class="product-snippet__image">
                    <a :href="item.url"
                       target="_blank">
                        <img v-if="item.images && item.images.length"
                             :src="item.images[0]"
                             class="product-thumbnail"
                             :alt="item.title">
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="426.41" height="325.68" viewBox="0 0 426.41 325.68">
                            <path d="M341.04.33C212.99,5.87,94.97,72.46,94.97,72.46c-192.94,115.24-32.17,188.43-32.17,188.43,80.84,40.08,186.36,59.93,186.36,59.93,2.69.61,5.3,1.14,7.87,1.6l-.03.02c3.24.61,23.84,4.7,44.76,2.69.67-.06,1.33-.13,1.98-.21.7-.08,1.4-.16,2.1-.25,1.41-.19,2.77-.41,4.1-.65.36-.07.72-.14,1.08-.21,1.36-.26,2.68-.55,3.96-.87.15-.04.3-.07.45-.11,21.73-5.46,31.25-17.6,36.64-24.17,49.4-63.6,70.7-185.14,70.7-185.14,12.21-62.71-8.24-90.84-31.62-103.32C367.78-2.79,341.04.33,341.04.33Z" fill="#e6e6e6"/>
                            <g fill="#fff">
                                <path d="M68.67,160.57h7.2c6.1,0,9.02-1.75,9.02-6.62s-2.92-6.49-9.02-6.49h-7.2v13.11ZM58.29,186.86v-48.02h18.04c11.81,0,18.88,4.22,18.88,14.86,0,7.59-3.57,11.75-9.99,13.69l10.71,19.47h-11.16l-9.99-18.11h-6.1v18.11h-10.39Z"/>
                                <path d="M120.78,168.49h11.29l-5.52-16.36h-.13l-5.65,16.36h.01ZM104.75,186.86l17-48.22h10.06l17,48.22h-10.71l-3.57-10.71h-16.35l-3.7,10.71h-9.73Z" />
                                <polygon points="159.71 186.86 159.71 138.84 170.29 138.84 190.41 169.47 190.54 169.47 190.54 138.84 200.27 138.84 200.27 186.86 190.54 186.86 169.58 155.97 169.45 155.97 169.45 186.86 159.72 186.86 159.71 186.86"/>
                                <path d="M213.07,175.95l7.98-4.74c2.66,5.26,7.46,8.18,12.98,8.18,4.87,0,8.37-1.82,8.37-5.52s-3.44-5.19-9.73-6.94c-8.57-2.4-17.52-4.61-17.52-14.67,0-8.96,7.01-14.34,17.33-14.34s15.7,4.74,19.08,9.86l-7.33,5.58c-2.53-4.09-7.14-6.81-11.81-6.81s-6.94,1.95-6.94,4.8c0,3.83,3.57,5.19,9.86,6.94,8.44,2.27,17.39,4.93,17.39,14.86,0,7.72-5.84,14.6-19.21,14.6-10.38,0-16.87-4.93-20.44-11.81h0Z" />
                                <path d="M297.55,162.84c0-10.06-4.67-16.16-12.07-16.16s-12.07,6.1-12.07,16.16,4.61,16.42,12.07,16.42,12.07-6.36,12.07-16.42ZM262.84,162.84c0-16.87,11.03-24.92,22.65-24.92s22.58,8.05,22.58,24.92-11.03,24.92-22.58,24.92-22.65-8.05-22.65-24.92Z"/>
                                <polygon points="320.27 186.86 320.27 138.84 330.85 138.84 350.97 169.47 351.1 169.47 351.1 138.84 360.83 138.84 360.83 186.86 351.1 186.86 330.14 155.97 330.01 155.97 330.01 186.86 320.28 186.86 320.27 186.86"/>
                            </g>
                        </svg>
                    </a>
                </div>

                <div class="product-snippet__info">
                    <a :href="item.url" class="block">
                        <div class="product-snippet__heading">
                            <span class="product-snippet__sku">
                                {{ item.sku }}
                                <i v-if="item.icon && isSales" v-html="item.icon" class="ml-1"></i>
                            </span>
                            <span class="tag tag--brown" v-if="item.ob">{{ $t("ob") }}</span>
                            <span class="tag" v-if="item.new">{{ $t("new") }}</span>
                            <span class="tag" v-if="item.promo">{{ $t("promo") }}</span>
                        </div>

                        <span class="product-snippet__title">{{ item.commercialName || item.title }}</span>

                        <small v-if="item.filters['Aantal in doos'] || item.weight || item.brand.title || item.volume" class="block">
                            <template v-if="item.filters['Aantal in doos'] > 1">
                                {{ item.filters["Aantal in doos"] }} {{ $t("stuks") }}
                                <template v-if="item.weight || item.volume">
                                    x
                                </template>
                            </template>
                            <template v-if="item.volume">
                                {{ item.volume >= 1000 ? `${item.volume / 1000} L` : `${item.volume} ml` }}
                            </template>
                            <template v-else-if="item.weight">
                                {{ item.weight >= 1000 ? `${item.weight / 1000} kg` : `${item.weight} g` }}
                            </template>
                            <span v-if="item.brand.title" class="relative z-50">
                                <template v-if="item.filters['Aantal in doos'] > 1 || item.weight  || item.volume">
                                 |
                                </template>
                                {{ item.brand.title }}
                            </span>
                        </small>

                        <!--<small v-if="item.numberOfProductsPerCase && item.ranWeightPerPrice"
                               class="block">{{ item.numberOfProductsPerCase }} stuk{{ item.numberOfProductsPerCase > 1 ? 's' : '' }} x {{ item.ranWeightPerPrice > 999 ? `${ item.ranWeightPerPrice / 1000 } kg` : `${ item.ranWeightPerPrice } g` }}</small>
                        <p v-if="item.description"
                           class="product-description">{{ item.description }}</p>-->
                        <button v-if="item.technicalSheet"
                                @click.prevent="technicalSheetUrl(user, item.objectID, item.technicalSheet, item.sku, item.commercialName || item.title)"
                                class="inline-block text-14 dt-colors hover:text-secondary mt-2">
                                <span class="fas fa-file-pdf mr-1" aria-hidden="true"></span>
                            {{ $t("Download technical sheet") }}
                        </button>
                    </a>
                </div>

                <div class="product-snippet__controls">
                    <span class="product-snippet__price">{{ formatCurrency(item.defaultPrice) }}</span>
                    <form class="form-add-to-cart">
                        <div class="form-add-to-cart__input-wrapper">
                            <label for="qty" class="sr-only">{{ $t("Aantal") }}</label>

                            <input type="number"
                                   class="form-add-to-cart__input qty"
                                   id="qty"
                                   name="qty"
                                   min="1"
                                   :value="productQty"
                                   @focus="focusQty"
                                   @blur="blurQty"
                                   @change="updateQty($event, item)" />

                            <template v-if="productsData.directOrder">
                                <button v-if="productsData.isSales"
                                        @click.prevent="addProductToCartModal(item)"
                                        class="form-add-to-cart__button">
                                    <span class="fas fa-pen" aria-hidden="true"></span>
                                </button>
                                <button v-if="productsData.directOrder"
                                        @click.prevent="addToCart(item)"
                                        class="form-add-to-cart__button form-add-to-cart__button--filled">
                                    <span class="fas fa-shopping-basket" aria-hidden="true"></span>
                                </button>
                            </template>
                            <template v-else>
                                <button @click.prevent="addToOrder(item)"
                                        class="form-add-to-cart__button form-add-to-cart__button--filled">
                                    <span class="fas fa-plus" aria-hidden="true" :title="$t('Toevoegen')"></span>
                                </button>
                            </template>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { helpers }                             from "@/js/mixins/helpers.js";
import AddToCartModal                          from "./AddToCartModal";
import { enableScrollLock, disableScrollLock } from "../js/helpers/scroll-lock";

export default {
    name: "AlternativesModal",

    mixins: [helpers],
    components: { AddToCartModal },

    data() {
        return {
            productsData: {
                alternatives: [],
                isSales: false,
                directOrder: true,
                chosenQuantity: 1
            },
            productQty: 1
        }
    },

    mounted() {
        this.productsData = this.$store.getters.getModalData('alternatives')
        this.productQty = this.productsData.chosenQuantity ?? 1
        // Set all products to the chosen quantity because if updateQty is not run the qty will remain 1 as this is what is saved in the product itself
        this.productsData.alternatives.forEach(product => {
            this.updateQty(null, product, this.productQty)
        })

        enableScrollLock();
    },

    methods: {
        closeModalOutside({target}) {
            const isPartOfModal = target.closest("#modal");
            if (isPartOfModal) return;
            this.closeModal();
        },

        closeModal() {
            disableScrollLock();

            this.$store.dispatch('toggleModal', { name: 'alternatives' })
            this.$emit('close-modal')
        },

        addProductToCartModal(item) {
            this.$store.dispatch('toggleModal', { name: 'addToCart', data: item })
        },

        addToCart(item) {
            this.$emit('add-to-cart', item)
            this.closeModal()
        },

        addToOrder(item) {
            item.type = 'saved'
            this.$emit('add-to-order', item)
            this.closeModal()
        },

        updateQty(e, product, quantity) {
            const qty = e ? parseInt(e.target.value) : quantity;
            if (qty > 0) product.qty = qty
        },
    }
}
</script>
